import store from "@/store/store.js";
import DEBUG from "@/store/debug.js";

export default async ({ commit }, decision) => {
    DEBUG("UPDATE_DECISION_START");
    try {
        commit("SET_DECISIONS_LOADING", true);
        const decisionRes = await window.app.$api.updateDecision(decision.id, decision);
        DEBUG("UPDATE_DECISION_SUCCESS");
        commit("UPDATE_DECISION", decisionRes.data);
    } catch (e) {
        DEBUG("UPDATE_DECISION_ERROR");
        throw e;
    } finally {
        commit("SET_DECISIONS_LOADING", false);
    }
};
